<div class="alert alert-danger panel-header" [ngClass]="{'ar': lang=='ar'}" (click)="toggleActivationStep()">
  <mat-icon class="fas fa-exclamation-circle" style="margin-top:2px;"></mat-icon>

  <span style="margin-top:-7px;display: inline-block;">{{'Sellers.Dashboard.CompleteContractSteps' | translate}}</span>
  <i class="fas " [ngClass]="{'fa-caret-down':!openContractService.contractStatus,'fa-caret-up':openContractService.contractStatus}"></i>
</div>
<div [ngStyle]="{'display': !openContractService.contractStatus?'none':'block'}">
  <app-business-bank-account></app-business-bank-account>
  <app-business-contract-data></app-business-contract-data>
  <app-contract-delivery-address></app-contract-delivery-address>
</div>
